import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { ProblemBullets } from './components/ProblemBullets';
import { Problem } from './components/Problem';
import { WhatYouGet } from './components/WhatYouGet';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
import { initMetaPixel } from './components/utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-dark text-gray-300 font-sans selection:bg-neon selection:text-black overflow-x-hidden" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      {/* Spacer for fixed urgency bar */}
      <div className="h-10 sm:h-11" aria-hidden="true" data-id="element-2" />

      <Hero data-id="element-3" />
      <ProblemBullets data-id="element-4" />
      <Problem data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <Testimonials data-id="element-7" />
      <Guarantee data-id="element-8" />
      <OfferBlock data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}